export default __webpack_public_path__ + "static/media/success.61e74882.gif";